import styled from 'styled-components';

export const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const SectionLabel = styled.span`
  color: #999;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const StatusChip = styled.span<{ bg: string; color: string }>`
  background: ${(p) => p.bg};
  color: ${(p) => p.color};
  font-size: 12px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 100px;
  letter-spacing: 0.02em;
`;

export const DocButton = styled.a`
  flex: 1;
  text-align: center;
  text-decoration: none;
  padding: 9px 12px;
  border-radius: 100px;
  border: 1px solid #0090d3;
  color: #0090d3;
  font-size: 13px;
  font-weight: 700;
  background: #fff;
`;

export const DocButtonsRow = styled.div`
  display: flex;
  gap: 10px;
`;

export const NegadaAlert = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
  background: #fdecee;
  border: 1px solid #f5c2c7;
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 12px;
  color: #c53030;
  line-height: 1.4;
`;

export const TotalRow = styled.div<{ $highlight?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${(p) => p.$highlight && 'color: #0090d3; font-size: 18px;'}
`;

export const TotalsDivider = styled.hr`
  border: 0;
  border-top: 1px solid #eee;
  margin: 0;
`;
